/**
 * Stable CSS class names for E2E — RuleServiceV2 wrapper.
 */
export const RSW = {
    breadcrumbSection: 'rule-service-wrapper__breadcrumb-section',
    loadingRow: 'rule-service-wrapper__loading-row',
    loadingSection: 'rule-service-wrapper__loading-section',
    tenantSelectSection: 'rule-service-wrapper__tenant-select-section',
    tabsSection: 'rule-service-wrapper__tabs-section',
} as const;

export const rswCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

